import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import Load from '../../template/Load/Load';
import AXIOS from '../../api/axios';
import { parseQuery } from '../../utils/tools';

import './style.less';

import vipImg from '../../static/images/vip.png';
import vipNoImg from '../../static/images/vip_no.png';

const queryObj = parseQuery(window.location.search.slice(1))

class MemberPage extends Component {
    constructor(props){
        super(props);
        this.state = {
            expireDate:null,
            completeRander:true
        };
    }
    componentDidMount(){
        AXIOS.getStuCourse({data:{stuId:queryObj.stuid}},(res,err)=>{
            if(err){
                // alert(JSON.stringify(err))
            }else{
                // alert(JSON.stringify(res))
                if(res[0]){
                    const expireDate = new Date(res[0].expireDate).getTime() + 86400000;
                    console.log(expireDate - new Date().getTime())
                    this.setState({ 
                        expireDate : expireDate - new Date().getTime() > 0 ? res[0].expireDate : null, 
                        completeRander  : true
                    })
                }else{
                    this.setState({ 
                        completeRander  : true
                    })
                }
            }
        })
    }
    render(){
        console.log(this.state.expireDate)
        return(
            <DocumentTitle title={'会员中心'}>
                <React.Fragment>
                {this.state.completeRander?
                    <div className="container member">
                        <div className="content_wrap">
                            <img src={this.state.expireDate?vipImg:vipNoImg} alt="img"/>
                            <div className="content_bottom">
                                <div className="title_wrap">
                                    <h2>{this.state.expireDate?'哈佛外教百科英语课程包':'您还不是哈佛外教百科英语课程的会员哦'}</h2>
                                    {this.state.expireDate?<h3>有效期至：{this.state.expireDate}</h3>:null}
                                </div>
                                <h3>课程说明</h3>
                                <p>
                                1.购买后请在有效期内使用，此课程仅限于哈佛外教百科英语课程系列；<br></br>
                                2.获取其它客户端下载链接和更多活动信息，请关注“爱课AirCourse”服务号；<br></br>
                                3.购买后7日内可无理由退款；<br></br>
                                4.如有其它任何疑问，请联系4008-874-877。
                                </p>
                            </div>
                        </div>
                    </div>:null
                }
                {!this.state.completeRander?<Load />:null}
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default MemberPage;



// WEBPACK FOOTER //
// ./src/components/memberPage/MemberPage.jsx